<template>
  <de-layout-content>
    <app-template-content :show-position="'system-setting'" />
  </de-layout-content>
</template>

<script>
import AppTemplateContent from '@/views/panel/appTemplate/AppTemplateContent'
export default {
  name: 'AppTemplate',
  components: {  AppTemplateContent }
}
</script>

